
import React from 'react';
import { Table, Spin} from 'antd';
import { FilePdfOutlined } from '@ant-design/icons';
import { HOST } from '../../constants';
import './index.css';
export const TableBox = (props) => {
  const { tableData, isShowSpin } = props;

  return (
    <div className="table-result">
      <div className="spin" >
        <Spin size="large" style={{ display: `${isShowSpin ? 'block' : 'none'}` }} > </Spin>
      </div>
      <Table columns={[
        {
          title: 'Decisions',
          dataIndex: 'url',
          key: 'url',
          render: (text, record, index) => <a href={text} rel="noopener noreferrer" target='_blank' > <FilePdfOutlined /> {record.name}</a>,
        },
      ]} dataSource={tableData.map((d, i) => ({
        key: i,
        name: d.name,
        url: HOST + d.url
      }))} />
    </div>
  );
}


